import { useMemo } from 'react';
import type { CommunicationDatabase } from '../../../../types';
import { useGetDocumentsByEntity } from '../../api/useGetDocumentsByEntity';
import { cleanCommunicationComment } from '../../utils/communicationComment';

type Props = {
  item: CommunicationDatabase;
};

export function useCommunicationCard(props: Props) {
  const { data: documents } = useGetDocumentsByEntity(
    { communicationId: props.item.id },
    true
  );

  const item = useMemo(
    () => ({ ...props.item, comment: cleanCommunicationComment(props.item.type, props.item.comment) }),
    [props.item]
  );

  return {
    item,
    documents: documents ?? [],
  };
}
